import { render, staticRenderFns } from "./HealthActionCardContainer.vue?vue&type=template&id=9d9c1d54"
import script from "./HealthActionCardContainer.vue?vue&type=script&lang=js"
export * from "./HealthActionCardContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports